import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-exam-marks',
  templateUrl: './exam-marks.component.html',
  styleUrls: ['./exam-marks.component.css']
})
export class ExamMarksComponent implements OnInit {
  myForm: FormGroup;
  table: Array<any> = [];
  isTable: Boolean = false;
  cources: Array<any> = [];
  payload: {};
  labelName: any = {};
  headingName: any = {};
  workItemId: any;

  constructor(private active : ActivatedRoute,private CommonService: CommonService, private fb: FormBuilder) {
    this.active.params.subscribe(res=>{
      this.workItemId = res.id
    })
    this.getCourses();
    this.getLabels();
    this.loadHeadings();

  }

  ngOnInit(): void {
    this.myForm = this.fb.group({
      class_id: ['']
    })

  }
  activeSpinner() {
    this.CommonService.activateSpinner();
  }

  deactivateSpinner() {
    this.CommonService.deactivateSpinner()
  }
  getLabels() {
    this.labelName = {};
    this.CommonService.getCall(`TenantRegistration/GetLabelValuesByTaskid/${this.workItemId}/${localStorage.getItem('TenantCode')}`).subscribe((res: any) => {
      this.labelName = res;
    })
  }

  loadHeadings() {
    this.headingName = {};
    this.CommonService.getCall(`EmsDynamicheadingLables/GetLabelValuesByTaskid/${this.workItemId}/${localStorage.getItem('TenantCode')}`).subscribe((res: any) => {
      this.headingName = res;
    })
  }

  getCourses() {
    this.activeSpinner()
    this.CommonService.getAdminCourses().subscribe((res: any) => {
      this.cources = res;
      this.deactivateSpinner()
    }, e => {
      this.deactivateSpinner()
    })
  }
  onSubmit(form: any) {
    let val = form.value;
    this.isTable = false;
    this.payload = {
      "course_id": val.class_id
    }
    this.CommonService.getCall(`EmsReports/StudentMarksReports/${val.class_id || 0}/${localStorage.getItem('TenantCode')}`).subscribe((res: any) => {
      this.table = res;
    })
  }
}
